<script>
export default {
  props: {
    title: { type: String, default: null },
    size: { type: String, default: 'md' },
    closeText: { type: String, default: 'Close' },
    value: { type: Boolean, default: false },
  },
}
</script>

<template>
  <transition name="fade">
    <div
      v-if="value"
      class="modal fixed w-full h-full top-0 left-0 z-10 flex items-center justify-center"
    >
      <div
        class="modal-overlay absolute w-full h-full bg-gray-900 opacity-50"
        @click="$emit('input', false)"
      ></div>

      <div
        class="modal-container bg-white w-11/12 mx-auto rounded-sm shadow-lg z-50 overflow-y-auto"
        :class="`md:max-w-${size}`"
      >
        <div class="modal-content py-4 text-left px-6">
          <div class="modal-header flex justify-between items-center mb-3">
            <h4 class="text-lg font-medium capitalize">{{ title }}</h4>
            <button class="modal-close" @click="$emit('input', false)">
              <i class="fas fa-times"></i>
            </button>
          </div>

          <div class="modal-body">
            <slot></slot>
          </div>

          <div class="modal-footer flex justify-end mt-3">
            <button class="btn" @click="$emit('input', false)">{{
              closeText
            }}</button>
            <slot name="modal-footer" />
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
